import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import FeaturedSeries from './components/FeaturedSeries';
import NewsSection from './components/NewsSection';
import ActorSidebar from './components/ActorSidebar';
import { usePageMeta } from '@/hooks/usePageMeta';

const quickEntries = [
  { label: '电视剧分类', desc: '按类型 / 地区 / 年份筛选', to: '/category/tv-series', icon: 'ri-tv-2-line', variant: 'primary' as const },
  { label: '影视资讯', desc: '行业动态与剧情解读', to: '/category/news', icon: 'ri-newspaper-line', variant: 'secondary' as const },
  { label: '演员动态', desc: '关注喜爱的演员近况', to: '/category/actors', icon: 'ri-user-star-line', variant: 'accent' as const },
  { label: '全站搜索', desc: '剧名 / 演员 / 资讯一搜即达', to: '/search', icon: 'ri-search-2-line', variant: 'neutral' as const },
];

const entryVariant: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
  accent: 'bg-accent-100 text-accent-800',
  neutral: 'bg-background-200 text-foreground-700',
};

export default function Home() {
  usePageMeta(
    '漂亮的姐姐 - 热门电视剧和影视资讯平台',
    '漂亮的姐姐提供最新影视剧信息、精彩剧情介绍和演员动态，涵盖多种类型电视剧和影视作品，助您轻松了解和追踪喜欢的影视内容。',
  );

  return (
    <div className="w-full max-w-page mx-auto px-4 md:px-6 py-6">
      <HeroCarousel />

      <section className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mt-6" aria-label="快捷入口">
        {quickEntries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-10 h-10 shrink-0 rounded-md flex items-center justify-center ${entryVariant[entry.variant]}`}>
              <i className={`${entry.icon} text-lg`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm font-bold text-foreground-950 whitespace-nowrap">{entry.label}</span>
              <span className="block text-xs text-foreground-500 truncate">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </section>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-8 flex flex-col gap-10">
          <FeaturedSeries />
          <NewsSection />
        </div>
        <div className="lg:col-span-4 flex flex-col gap-6">
          <ActorSidebar />
          <div className="p-5 rounded-lg bg-primary-900 text-background-100">
            <h2 className="font-heading text-lg font-bold text-background-50">关于漂亮的姐姐</h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-100">
              我们聚合最新影视剧信息与行业动态，用清晰的分类与筛选帮助你快速找到想看的作品，
              深入了解剧情故事，追踪喜爱的演员近况。
            </p>
            <dl className="mt-5 grid grid-cols-3 gap-3 text-center">
              <div className="p-3 rounded-md bg-primary-800">
                <dt className="text-xs text-primary-200">收录剧集</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">1200+</dd>
              </div>
              <div className="p-3 rounded-md bg-primary-800">
                <dt className="text-xs text-primary-200">资讯文章</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">3400+</dd>
              </div>
              <div className="p-3 rounded-md bg-primary-800">
                <dt className="text-xs text-primary-200">演员资料</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">2600+</dd>
              </div>
            </dl>
            <Link
              to="/about"
              className="mt-5 flex items-center justify-center gap-1 w-full py-2.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}